var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{class:{
    'table-warning': _vm.totalSeconds >= 60 && _vm.totalSeconds < 120,
    'table-success': _vm.totalSeconds < 60,
    'table-danger': _vm.totalSeconds >= 120
  },domProps:{"innerHTML":_vm._s(_vm.time)}})
}
var staticRenderFns = []

export { render, staticRenderFns }